import { isNumber as globalIsNumber, exists as globalExists } from 'utils/global';
import { get as persistentGet } from 'utils/persistent';

/**
 *
 * @param {Object} numformat
 * @param {unknown} target
 */
export const applyToDisplay = (numformat, target) => {
    if (undefined != numformat) {
        $('input.formatNum', target).each(function () {
            $(this).val(formatToDisplay($(this).val(), numformat));
            $(this).change(function () {
                var toFloat = formatToFloat($(this).val(), numformat);
                $(this).val(formatToDisplay(toFloat, numformat));
            });
        });
        $('span.formatNum', target).each(function () {
            $(this).html(formatToDisplay($(this).html(), numformat));
        });
    }
};

/**
 *
 * @param {number} number
 * @param {Object} numformat
 */
export const arround = (number, numformat) => {
    number = parseFloat(number.toFixed(parseInt(numformat.precision, 10)), 10);
    return number;
};

/**
 *
 * @param {number} number
 * @param {Object} inputFormat
 * @param {Object} outputFormat
 * @param {String} precisioncustom
 */
export const convert = (number, inputFormat, outputFormat, precisioncustom) => {
    var floatNum = formatToFloat(number, inputFormat);
    var numberFormat = formatToDisplay(floatNum, outputFormat, true, precisioncustom);
    return numberFormat;
};

/**
 *
 * @param {Object} numformat
 */
export const currencyToLeft = (numformat) => {
    return 'left' == numformat.currencypos || 'both' == numformat.currencypos;
};

/**
 *
 * @param {Object} numformat
 */
export const currencyToRight = (numformat) => {
    return 'right' == numformat.currencypos || 'both' == numformat.currencypos;
};

/**
 *
 * @param {number} number
 * @param {Object} numformat
 * @param {Boolean} isAlreadyFloat
 * @param {String} precisioncustom
 */
export const formatToDisplay = (number, numformat, isAlreadyFloat, precisioncustom) => {
    // Parse given 'number' into float
    if (isAlreadyFloat == undefined) {
        var floatReg = /^[+-]?\d+(\.\d+)?$/;
        if (floatReg.test(number)) {
            number = parseFloat(number, 10);
        } else {
            number = formatToFloat('' + number, numformat);
        }
    } else {
        number = parseFloat(number, 10);
    }

    // Select decimal number
    var precisionToApply = getPrecisionToApply(numformat, precisioncustom);

    const rounded = number.toFixed(precisionToApply);
    const parts = rounded.split('.');
    // Apply thousand separtor to integer part
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, numformat.thousands);
    return parts.join(numformat.decimals);
};

/**
 *
 * @param {number} number
 * @param {Object} numformat
 * @param {Boolean} isAlreadyFloat
 */
export const formatToDisplayWithCurrency = (number, numformat, isAlreadyFloat) => {
    if (globalIsNumber(number)) {
        const result = formatToDisplay(number, numformat, isAlreadyFloat);
        const currency = numformat.currency || numformat.currencysymbol;

        switch (numformat.currencypos) {
            case 'left':
                return `${currency} ${result}`;
            case 'both':
                return `${currency} ${result} ${currency}`;
            default:
            case 'right':
                return `${result} ${currency}`;
        }
    }

    return false;
};

/**
 *
 * @param {number} number
 * @param {Object} numformat
 */
export const formatToFloat = (number, numformat) => {
    number = '' + number;
    if ('' == number) {
        number = '0';
    }

    // split decimal and Int part
    var parts = number.split('' + numformat.decimals);
    var intPart = parts[0] != undefined ? '' + parts[0] : '0';
    var decPart = parts[1] != undefined ? '' + parts[1] : '0';
    intPart = intPart.split(numformat.thousands).join('');

    var numFloat = intPart;
    if (decPart != '') {
        numFloat += '.' + decPart;
    }

    var result = parseFloat(numFloat, 10);
    if (isNaN(result)) {
        result = 0;
    }
    return result;
};

/**
 * @param {Object} numformat
 * @param {String} precisioncustom
 */
export const getPrecisionToApply = (numformat, precisioncustom) => {
    var wantPrecisionCustom = precisioncustom != undefined;
    var hasPrecisionCustom =
        numformat.precisioncustom != undefined &&
        numformat.precisioncustom[precisioncustom] &&
        numformat.precisioncustom[precisioncustom] != 'default';
    if (wantPrecisionCustom && hasPrecisionCustom) {
        return numformat.precisioncustom[precisioncustom];
    }
    return numformat.precision;
};

/**
 *
 * @param {Object} numformat
 * @param {boolean} toDisplay
 */
export const getZero = (numformat, toDisplay) => {
    toDisplay = undefined == toDisplay ? true : toDisplay;
    return toDisplay ? formatToDisplay(0, numformat) : formatToFloat('0', numformat);
};

/**
 * @param {string} persistentVar
 * @param {string} inputsprefix
 */
export const load = (persistentVar, inputsprefix) => {
    persistentVar = undefined == persistentVar ? 'numformat' : persistentVar;
    inputsprefix = undefined == inputsprefix ? '' : inputsprefix;

    var numformat = persistentGet(persistentVar, true);
    if (!numformat) {
        numformat = loadFromInputs(inputsprefix);
    }

    return numformat;
};

/**
 *
 * @param {string} inputsprefix
 */
export const loadFromInputs = (inputsprefix) => {
    inputsprefix = undefined === inputsprefix ? '' : inputsprefix;

    var numformat = {};
    numformat.currency = globalExists(inputsprefix + 'currency')
        ? $('#' + inputsprefix + 'currency').val()
        : '';
    numformat.currencypos = globalExists(inputsprefix + 'currencypos')
        ? $('#' + inputsprefix + 'currencypos').val()
        : '';
    numformat.decimals = globalExists(inputsprefix + 'decimals')
        ? $('#' + inputsprefix + 'decimals').val()
        : '';
    numformat.name = globalExists(inputsprefix + 'name')
        ? $('#' + inputsprefix + 'name').val()
        : '';
    numformat.position = globalExists(inputsprefix + 'position')
        ? $('#' + inputsprefix + 'position').val()
        : '';
    numformat.thousands = globalExists(inputsprefix + 'thousands')
        ? $('#' + inputsprefix + 'thousands').val()
        : '';
    numformat.precision = globalExists(inputsprefix + 'precision')
        ? $('#' + inputsprefix + 'precision').val()
        : '';

    numformat.precisioncustom = {};
    var customPrecision = $('input[name^=' + inputsprefix + 'precisioncustom]');
    $.each(customPrecision, function (k, v) {
        var col = $(v).attr('id').split('_')[2];
        var val = $(v).val();
        numformat.precisioncustom[col] = val;
    });

    return numformat;
};
